import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TransitionService } from "@uirouter/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class StatsmanService {
  private cache: Map<string, Observable<any>>;

  constructor(
    private http: HttpClient,
    private $transitions: TransitionService,
  ) {
    this.cache = new Map();
    this.$transitions.onStart({}, () => {
      this.cache.clear();
    });
  }

  public query(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/metrics`;
    return this.fetchWithCaching(url, params);
  }

  public queryGroupNoticesCount(params: any) {
    let groupId: any;
    let projectId: any;
    [params, projectId, groupId] = splayParams(params, "projectId", "groupId");
    params.type = "counter";
    const url = `/api/v4/projects/${projectId}/metrics/groups.${groupId}.total_notices`;
    return this.fetchWithCaching(url, params);
  }

  private fetchWithCaching(url: string, params: any) {
    const cacheKey = `q:${JSON.stringify({ url, params })}`;
    if (!this.cache.get(cacheKey)) {
      this.cache.set(
        cacheKey,
        this.http.get(url, { params }).pipe(shareReplay(1)),
      );
    }
    return this.cache.get(cacheKey);
  }
}
